var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddedIdCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2ED134"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.907 30.3366L31.7223 20.5213L29.9772 18.8023L21.907 26.8725L17.8573 22.8229L16.1466 24.5418L21.907 30.3366ZM23.952 37.91C22.0398 37.91 20.2353 37.5448 18.5383 36.8146C16.8414 36.0842 15.3592 35.0854 14.0919 33.8181C12.8246 32.5508 11.8258 31.069 11.0954 29.3728C10.3651 27.6766 10 25.8724 10 23.9603C10 22.0252 10.3651 20.2092 11.0954 18.5122C11.8258 16.8153 12.8242 15.3387 14.0906 14.0825C15.3571 12.8264 16.8386 11.8319 18.5352 11.0992C20.2318 10.3664 22.0364 10 23.9491 10C25.8846 10 27.7012 10.3662 29.3987 11.0985C31.0964 11.8309 32.573 12.8248 33.8288 14.0802C35.0845 15.3356 36.0787 16.8119 36.8112 18.5091C37.5437 20.2063 37.91 22.0229 37.91 23.9591C37.91 25.8721 37.5436 27.6769 36.8108 29.3738C36.0781 31.0707 35.0836 32.5524 33.8275 33.8191C32.5713 35.0857 31.0951 36.0842 29.3989 36.8146C27.7027 37.5448 25.8871 37.91 23.952 37.91ZM23.9509 35.5688C27.182 35.5688 29.9248 34.4376 32.1791 32.1753C34.4334 29.913 35.5606 27.1743 35.5606 23.9591C35.5606 20.728 34.4334 17.9852 32.1791 15.7309C29.9248 13.4766 27.1807 12.3494 23.9468 12.3494C20.7357 12.3494 17.9987 13.4766 15.7357 15.7309C13.4727 17.9852 12.3412 20.7293 12.3412 23.9632C12.3412 27.1743 13.4724 29.9113 15.7347 32.1743C17.997 34.4373 20.7357 35.5688 23.9509 35.5688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedIdCar);
export default __webpack_public_path__ + "static/media/added_id_car.fa23c6d908660c9a7dc1ccd8d9e43c57.svg";
export { ForwardRef as ReactComponent };